import React, { useEffect, useState } from 'react';
import '../css/navBar.css'
import flechaPaginacion from '../assets/flechaPaginacion.png';
import flechaPaginacionBlanca from '../assets/flechaSelect.png';

export const Paginacion = ({ isTablaActividades, cambiarPagina, cantPaginas = 1, pagActual, setPagActual }) => {

    //const [claseAgregada, setClaseAgregada] = useState("");
    //const [cantPags, setCantPags] = useState(1);
    const [cantPagsMaxima, setCantPagsMaxima] = useState(1);

    const textClass = isTablaActividades ? "text-white" : "";
    const cantPagesShow = Math.min(cantPaginas, cantPagsMaxima);
    /* useEffect(() => {
         if (isTablaActividades === true) {
             setClaseAgregada("text-white");
         }
         //setCantPags(cantPaginas);
         //mostrarPagina(1, true)
     }, [cantPaginas])*/
    useEffect(() => {
        if (window.screen.availWidth > 750)
            setCantPagsMaxima(5);
        else if (window.screen.availWidth > 550)
            setCantPagsMaxima(3);
        else
            setCantPagsMaxima(1);
    }, [])
    function mostrarPagina(idPag, inicio) {
        /*const idAct = localStorage.getItem(process.env.REACT_APP_ID_ACTIVIDAD);
        var cantMargen = Math.floor(cantPagsMaxima / 2);
        if (parseInt(idAct) !== -1 && idPag !== null) {


            if (!inicio && cantPaginas > cantPagsMaxima) {
                if (pagActual < cantPagsMaxima - cantMargen) {
                    var inicioCont = 1;
                    var finCont = cantPagsMaxima;
                }
                else if (pagActual > cantPaginas - cantMargen) {
                    var inicioCont = cantPaginas - cantPagsMaxima;
                    var finCont = cantPaginas;
                }
                else {
                    var inicioCont = pagActual - cantMargen;
                    var finCont = pagActual + cantMargen;
                }
                 for (var x = inicioCont; x <= finCont; x++)
                     document.getElementById("idPag" + x).classList.add("d-none");


                if (idPag < cantPagsMaxima - cantMargen) {
                    var inicioCont = 1;
                    var finCont = cantPagsMaxima;
                }
                else if (idPag > cantPaginas - cantMargen) {
                    var inicioCont = cantPaginas - (cantPagsMaxima - 1);
                    var finCont = cantPaginas;
                }
                else {
                    var inicioCont = idPag - cantMargen;
                    var finCont = idPag + cantMargen;
                }*/

        /*  for (var x = inicioCont; x <= finCont; x++)
              document.getElementById("idPag" + x).classList.remove("d-none");*/


        /*  const puntosInicio = document.getElementById("puntosFin");
           if (puntosInicio !== null) {
                if (idPag > cantPagsMaxima - cantMargen) {
                    if (inicioCont !== 2)
                        puntosInicio.classList.remove("d-none");
                    else
                        puntosInicio.classList.add("d-none");
                }
                else {
                    puntosInicio.classList.add("d-none");
                }
            }
 
            if (idPag > cantPagsMaxima - cantMargen)
                document.getElementById("idPagInicio").classList.remove("d-none");
            else
                document.getElementById("idPagInicio").classList.add("d-none");
            const puntosFin = document.getElementById("puntosFin");
            if (puntosFin !== null) {
                if (idPag < cantPags - cantMargen) {
                    if (finCont !== cantPags - 1)
                        puntosFin.classList.remove("d-none");
                    else
                        puntosFin.classList.add("d-none");
                }
                else {
                    puntosFin.classList.add("d-none");
                }
            }
 
            if (idPag < cantPags - cantMargen)
                document.getElementById("idPagFin").classList.remove("d-none");
            else
                document.getElementById("idPagFin").classList.add("d-none");
     }*/
        /* console.log(pagActual)
         const pagAnt = document.getElementById("idPag" + pagActual);
         pagAnt.classList.remove("active");
         const pagAct = document.getElementById("idPag" + idPag);
         pagAct.classList.add("active");*/
        setPagActual(idPag);
        if (!inicio && isTablaActividades) cambiarPagina(idPag);
        // }
    }

    /*  function paginaSiguiente() {
  
          if (cantPaginas > pagActual) {
              const pagAnt = document.getElementById("idPag" + pagActual);
              pagAnt.classList.remove("active");
              const pagAct = document.getElementById("idPag" + (pagActual + 1));
              pagAct.classList.add("active")
              setPagActual(pagActual + 1);
              mostrarPagina(pagActual + 1, false)
              if (isTablaActividades) cambiarPagina(pagActual + 1);;
          }
      }*/

    /*  function paginaAnterior() {
       if (pagActual > 1) {
             const pagAnt = document.getElementById("idPag" + pagActual);
             pagAnt.classList.remove("active");
             const pagAct = document.getElementById("idPag" + (pagActual - 1));
             pagAct.classList.add("active");
 
             setPagActual(pagActual - 1);
             mostrarPagina(pagActual - 1, false)
         }
    }*/
    // PaginationButton.jsx
    const PaginationButton = ({ isPrev = false, disabled, isActivityTable, onClick }) => {

        const arrowClass = isActivityTable
            ? isPrev
                ? "flechaIzqBlanca"
                : "flechaDerBlanca mt-flechas"
            : "flechaPaginacion" + (!isPrev ? " mt-flechas" : "");

        const Arrow = () =>
            isActivityTable ? (
                <img
                    className={`${isPrev ? "me-2" : "ms-2"} ${arrowClass}`}
                    src={flechaPaginacionBlanca}
                    alt=""
                />
            ) : (
                <div
                    className={`${isPrev ? "me-2 flechaInvertida" : "ms-2"} ${arrowClass}`}
                />
            );

        return (
            <div className={`page-item ${disabled ? "disabled" : ""}`}>
                <a
                    className={`page-link centrarContainer ${textClass} d-inline-flex`}
                    href="#"
                    onClick={!disabled ? onClick : undefined}
                >
                    {isPrev && <Arrow />}
                    <div className="ocultarPaginacionMobile">
                        {isPrev ? "Anterior" : "Siguiente"}
                    </div>
                    {!isPrev && <Arrow />}
                </a>
            </div>
        );
    };

    const getPageId = (index) => { 
        if (index === 0) return 1;
        if (index === cantPagesShow - 1) return cantPaginas;

        let middle = [pagActual - 1, pagActual, pagActual + 1]
            .filter(p => p > 1 && p < cantPaginas);

        while (middle.length < cantPagesShow - 2) {
            const last = middle[middle.length - 1] || 1;
            const next = last + 1;

            if (next < cantPaginas)
                middle.push(next);
            else
                middle.unshift(middle[0] - 1);

        }

        return middle[index - 1];
    };

    return (
        <>
            <div className='container-fluid position-absolute bottom-0 start-0 ' id="paginacion">
                <div className='row align-items-center px-3'>
                    <div className='col'>
                        {/*isTablaActividades === true ?
                            <div id="anterior" className={`page-item ${pagActual === 1 ? 'disabled' : ''}`}>
                                <a class="page-link centrarContainer text-white" href='#' onClick={() => setPagActual(pagActual - 1)}>
                                    <img className='me-2 flechaIzqBlanca' src={flechaPaginacionBlanca} alt="" />
                                    <div className='ocultarPaginacionMobile'>Anterior</div>
                                </a>
                            </div>
                            :
                            <div id="anterior" className={`page-item ${pagActual === 1 ? 'disabled' : ''}`}>
                                <a class="page-link centrarContainer" href='#' onClick={() => setPagActual(pagActual - 1)}>
                                    <div className='me-2 flechaInvertida flechaPaginacion' src={flechaPaginacion} />
                                    {/*<img className='me-2 flechaInvertida' src={flechaPaginacion} alt=""/>* /}
                                    <div className='ocultarPaginacionMobile'>Anterior</div>
                                </a>
                            </div>*/
                        }
                        <PaginationButton
                            isPrev
                            disabled={pagActual === 1}
                            isActivityTable={isTablaActividades}
                            onClick={() => mostrarPagina(pagActual - 1)}
                        />
                    </div>
                    <div className='col'>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination justify-content-center py-3 mb-0">
                                {/*cantPags > cantPagsMaxima ?
                                    <>
                                        <li id='idPagInicio' class="page-item d-none" onClick={() => mostrarPagina(1)}><a class={"page-link mx-2 " + claseAgregada} href='#'>01</a></li>
                                        {cantPags > cantPagsMaxima + 1 ?
                                            <li id='puntosInicio' class="page-item d-none"><a class={"page-link puntosPaginacion mx-2 " + claseAgregada}>...</a></li>
                                            :
                                            <></>
                                        }
                                    </>
                                    :
                                    <></>
                                */}

                                {/** /                                  i < cantPagsMaxima &&*/}
                                {[...Array(cantPagesShow)].map((x, i) => {
                                    const id = getPageId(i)

                                    return (
                                        <>
                                            <li id={'idPag' + id} className={`page-item ${pagActual === id ? 'active' : ''}`} onClick={() => mostrarPagina(id)}>
                                                <a class={"page-link mx-2 " + textClass} href='#'>{id.toString().padStart(2, "0")}</a>
                                            </li>
                                            {
                                                (i === 0 && pagActual > 2 || i == cantPagsMaxima - 2 && pagActual < cantPaginas - 2) && cantPaginas > cantPagsMaxima &&
                                                <li id='puntosInicio' class="page-item " > <a class={"page-link puntosPaginacion mx-2 " + textClass}>...</a></li>
                                            }
                                        </>
                                    )
                                }

                                )
                                }


                                {/*  : i < cantPagsMaxima ?
                                            <>
                                                <li id={'idPag' + (i + 1)} class="page-item" onClick={() => mostrarPagina(i + 1)}><a class={"page-link mx-2 " + claseAgregada} href='#'>{"0" + (i + 1)}</a></li>
                                            </>
                                            : i < 9 ?
                                                <li id={'idPag' + (i + 1)} class="page-item d-none" onClick={() => mostrarPagina(i + 1)}><a class={"page-link mx-2 " + claseAgregada} href='#'>{(i + 1).toString().padStart(2, "0")}</a></li>
                                                :
                                                <>
                                                    <li id={'idPag' + (i + 1)} class="page-item d-none" onClick={() => mostrarPagina(i + 1)}><a class={"page-link mx-2 " + claseAgregada} href='#'>{i + 1}</a></li>
                                                </>*/}
                                {/*cantPags > cantPagsMaxima ?
                                    <>
                                        {cantPags > cantPagsMaxima + 1 ?
                                            <li class="page-item" id="puntosFin"><a class={"page-link puntosPaginacion mx-2 " + claseAgregada}>...</a></li>
                                            :
                                            <></>
                                        }
                                        {cantPags < 10 ?
                                            <li id='idPagFin' class="page-item" onClick={() => mostrarPagina(cantPags)}><a class={"page-link mx-2 " + claseAgregada} href='#'>{"0" + cantPags}</a></li>
                                            :
                                            <li id='idPagFin' class="page-item" onClick={() => mostrarPagina(cantPags)}><a class={"page-link mx-2 " + claseAgregada} href='#'>{cantPags}</a></li>
                                        }
                                    </>
                                    :
                                    <></>
                                */}
                            </ul>
                        </nav>
                    </div>
                    <div className='col text-end'>

                        {/*isTablaActividades === true ?
                            <div class="page-item">
                                <div id="siguiente" className={`d-inline-block ${pagActual === cantPaginas ? 'disabled' : ''}`}>
                                    <a class="page-link centrarContainer text-white" href='#' onClick={() => setPagActual(pagActual + 1)}>
                                        <div className='ocultarPaginacionMobile'>Siguiente</div>
                                        <img className='ms-2 flechaDerBlanca mt-flechas' src={flechaPaginacionBlanca} alt="" />
                                    </a>
                                </div>
                            </div>
                            :
                            <div class="page-item">
                                <div id="siguiente" className={`d-inline-block ${pagActual === cantPaginas ? 'disabled' : ''}`}>
                                    <a class="page-link centrarContainer" href='#' onClick={() => setPagActual(pagActual + 1)}>
                                        <div className='ocultarPaginacionMobile'>Siguiente</div>
                                        {/*<img className='ms-2 mt-flechas' src={flechaPaginacion} alt=""/>* /}
                                        <div className='ms-2 flechaPaginacion' alt="" />
                                    </a>
                                </div>
                            </div>*/
                        }
                        <PaginationButton
                            disabled={pagActual === cantPaginas}
                            isActivityTable={isTablaActividades}
                            onClick={() => mostrarPagina(pagActual + 1)}
                        />
                    </div>
                </div>
            </div >
        </>
    );
}


export default Paginacion;